import { EntityQuery, FilterQueryOp, Predicate } from 'breeze-client';

const baseQuery = EntityQuery.from('DatasetAccesses');

function selectByPrincipal(principalIds: string | string[]): EntityQuery {
  const ids = Array.isArray(principalIds) ? principalIds : [principalIds];
  return baseQuery.where(Predicate.create('identityPrincipalId', FilterQueryOp.In, ids));
}

export const datasetAccessQueries = {
  selectAll: baseQuery,
  selectByPrincipal
};
